import {Injectable} from '@angular/core';
import {LogPublisher} from "../log-publisher.interface";

@Injectable({
  providedIn: 'root'
})
export class LogConsoleService implements LogPublisher {
  debug(message: string, optionalParams: any[]): void {
    console.log(message, optionalParams);
  }

  info(message: string, optionalParams: any[]): void {
    console.info(message, optionalParams);
  }

  warn(message: string, optionalParams: any[]): void {
    console.warn(message, optionalParams);
  }

  error(message: string, optionalParams: any[]): void {
    console.error(message, optionalParams);
  }
}
